import { HttpService, BaseRepository } from '@Ravnur-Inc/http';

import pathes from '@/config/pathes';
import { Job, Job$Response } from '@Ravnur-Inc/shared/types/Job';

type JobsRepositoryQueryParams = {
  id: string[];
  mediaId: string[];
};

export default class JobsRepository extends BaseRepository<Job, JobsRepositoryQueryParams> {
  constructor() {
    super(pathes.JOB);
  }

  public async monitor(params: Record<string, unknown> = {}): Promise<Job$Response[]> {
    return HttpService.get(`${this._resource}/current`, { params });
  }
}
